import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { App } from '@df/core/app';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { ICmsDataChangeService, NICmsDataChange } from '@icms/core/data/change/icms-data-change.service';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { CmsOutletBlockComponent } from '../../outlet/block/cms-outlet-block.component';
import { CMS_COMPONENT_CONTENT_BLOCK_CONFIG } from './cms-component-content-block.config';
import { NCmsComponentContentBlock } from './cms-component-content-block.interface';

@Component({
    selector: 'content-block',
    templateUrl: './cms-component-content-block.component.html',
    standalone: true,
    imports: [CmsOutletBlockComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentContentBlockComponent>(CMS_COMPONENT_CONTENT_BLOCK_CONFIG)
export class CmsComponentContentBlockComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentContentBlock.IData;

    readonly ID = NCmsComponentContentBlock.ID;
    public variant?: string;

    protected app = inject(App);
    protected iCmsDataChangeService = inject(ICmsDataChangeService);

    override ngOnInit(): void {
        super.ngOnInit();

        this.setModel();

        this.subscriptions.add(
            this.iCmsDataChangeService.afterChange$.subscribe(event => {
                if (event.changeType === NICmsDataChange.EChangeType.change && ['block'].some(path => event.valuePath.includes(path))) {
                    this.setModel();
                }
            })
        );
    }

    protected setModel(): void {
        const block = this.component.block;

        if (block) {
            this.app.resources[ICmsBlock.type].load(this.component.block, 1).then(block => {
                if (block.data) {
                    const [_baseUrl, variant] = block.data.url.split('@');

                    this.variant = variant;

                    this.detectChanges();
                }
            });
        }
    }
}
